import React from 'react';
// @ts-ignore
import Slider from 'react-slick';
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';
import Image from 'next/image'
import {  categoryIdTranslations } from '@/src/app/[locale]/helpers/utils'
import { useTranslations } from 'next-intl'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DummyImage from '@/src/app/[locale]/assets/images/dummy-image.jpg'

const CardSlider = ({ images, estateData }: {images: any, estateData: any}) => {
  const t = useTranslations('')

  function NextArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div
        className={`${className} card-slider-arrow`}
        style={{ bottom: "17" }}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div
        className={`${className} card-slider-arrow`}
        style={{ bottom: "17" }}
        onClick={onClick}
      />
    );
  }

  const settingsMain = {
    arrows: true,
    dots: true,
    infinite: images ? images.length > 1 : 0,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };


  return (
    <div className="card-slider">
      { images &&
          <Slider {...settingsMain}>
          {images.map((image: any, index: number) => {
            return (
              <div key={index} data-src={image}>
                <img
                  src={image}
                  height={276}
                  alt={`${t(categoryIdTranslations[estateData.category])} ${t('Code')} ${estateData.code}`}
                />
              </div>
            );
          })}
        </Slider>

      }

      {
        !images &&
          <Image
            src={DummyImage}
            width='370'
            height='275'
            unoptimized={true}
            alt=''
            title=''
          />
      }
    </div>
  );
};

export default CardSlider;
